/**
 * App Frontent constants
 *
 * *** IMP: Do not add any sensitive data here - This will be included in the client side artifacts
 */


export default class Constants {

  public static readonly APP_NAME = "PowerX"

  // URLs — externalized via VUE_APP_* (D6.3). Docker Compose / .env set these;
  // fallbacks match the default bridge-network topology for local dev only.
  public static readonly SERVER_URL =
    process.env.VUE_APP_SERVER_URL || "http://10.0.0.15:5000"
  public static readonly APP_URL =
    process.env.VUE_APP_APP_URL || "http://10.0.0.10:8080"

  // Cookies
  public static readonly ACCESS_TOKEN = "access_token"
  public static readonly REFRESH_TOKEN = "refresh_token"

  // Events
  public static readonly EVENTS = {
    CLOSED: "closed",
    SHOW_LOADING: "showLoading",
    SHOW_MESSAGE: "showMessage",
    SHOW_MESSAGE_DIALOG: "showMessageDialog",
    SET_TOP_MENU_POSITION: "setTopMenuPosition",
    SET_TOAST_POSITION: "setToastPosition",
    THEME_CHANGED: "changeTheme",
    AUTH_CHANGED: "authChanged",
    APP_MODE_CHANGED: "appModeChanged",
    STATUS_ALERT_MUTE_CHANGED: "statusAlertMuteChanged",
    STATUS_ALERT_SOUND_CHANGED: "statusAlertSoundChanged",
    STATUS_ALERT_SIMULATION_CHANGED: "statusAlertSimulationChanged",
  }

  // Local Storage IDs
  public static readonly LOCAL_STORAGE_IDS = {
    APP_MODE: "app_mode",
    MENU_POSITION: "menu_position",
    TOAST_POSITION: "toast_position",
    THEME: "theme",
    ACCESS_TOKEN: "access_token",
    STATUS_ALERT_MUTED: "status_alert_muted",
    STATUS_ALERT_SOUND: "status_alert_sound",
  }

  // Process ID
  public static readonly OPID = {
    READ: 0,
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
  }
  public static readonly PID_LENGTH = {
    [Constants.OPID.READ]: 15,
    [Constants.OPID.ADD]: 15,
    [Constants.OPID.UPDATE]: 15,
    [Constants.OPID.DELETE]: 15,
  }

  // Month to number map
  public static readonly MONTH_TO_NUMBER = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ]


}
